import { useDispatch, useSelector } from 'react-redux';
import { GraphicDimensions, GreenroomState } from '../stores/types/types';
import { DRAG_TYPE, DragItem, RelativePosition } from '../stores/reducers/user-interface';
import { getMediaDimensionsGivenUrl } from '../utils/media';
import { getDimensionsOfGraphic } from '../utils/custom-graphics';
import { editGraphicsAction } from '../stores/actions/graphics';

const useInitOverlayTransform = () => {
	const shots = useSelector((state: GreenroomState) => state.ShotsReducer.shots);
	const token = useSelector((state: GreenroomState) => state.SessionReducer.token);
	const graphics = useSelector((state: GreenroomState) => state.GraphicsReducer.graphics);
	const dispatch = useDispatch();

	// when an overlay is dropped onto canvas, we want to calculate its initial position
	const calcPositionOnAdd = async (
		item: DragItem,
		mousePos: RelativePosition,
	) => {
		const { id, type } = item;

		// title initial position is calc'd in saveTitleAsOverlay()
		if (type !== DRAG_TYPE.OVERLAY || !token || typeof id !== 'number') {
			return;
		}

		// if exists in show, use existing position
		const currGraphic = graphics.find((graphic) => graphic.id === id);
		const isInShow = shots.some((shot) => shot.shot_data.shotGraphics?.includes(id));
		if (!currGraphic || isInShow) {
			return;
		}

		// calc new position given mouse position relative to canvas
		const posX = Math.round(mousePos.x - (currGraphic.scale_x / 2));
		const posY = Math.round(mousePos.y - (currGraphic.scale_y / 2));

		let dimensionsAdjusted: GraphicDimensions = { xScale: -1, yScale: -1 };
		const dimensionsInPx = await getMediaDimensionsGivenUrl(currGraphic.images);
		dimensionsAdjusted = getDimensionsOfGraphic(dimensionsInPx);

		// reset all positioning (keep animation)
		currGraphic.scale_x = dimensionsAdjusted.xScale;
		currGraphic.scale_y = dimensionsAdjusted.yScale;
		currGraphic.pos_x = posX;
		currGraphic.pos_y = posY;
		currGraphic.rotate = 0;

		dispatch(editGraphicsAction(token, currGraphic, () => { }));
	};

	return { calcPositionOnAdd };
};

export default useInitOverlayTransform;
